// The jQuery plugins only the not-yet-rebuilt pages still need, fetched on
// demand instead of shipped to everyone.
//
// fancybox and tooltipster were top-level imports in setup.js, so every
// desktop page on every brand downloaded, parsed and evaluated them. On the
// rebuilt pages nothing ever called them: fancybox survives only in the
// `else` arms that the .tw-page checks skip (setup.js's flash dialog,
// booking/index.ts's error popup, alerts.ts), and tooltipster only in
// booking/index.ts's `$(".tip")` call, behind that same check. The rebuilt
// funnel replaced both with hand-authored Tailwind dialogs and Stimulus
// controllers.
//
// A dynamic import is what makes that pay off: webpack emits these as their
// own chunk, so the bytes are only fetched when one of those legacy arms
// actually runs. Deleting them outright is not an option -- fixtravel and
// supremecard are not rebuilt, and a handful of pages on the rebuilt brands
// (show_booking, booking#hotel) still take these paths.
//
// The promise is cached, so several call sites on one page share a single
// fetch and the plugins register on jQuery exactly once.
let pending;

export function loadLegacyPlugins() {
  if (!pending) {
    pending = import(/* webpackChunkName: "legacy-jquery-plugins" */ "./legacy_plugins_bundle");
  }
  return pending;
}
